import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackRemoveFromCartParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackRemoveFromCart";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackRemoveFromCart = (
    parameters: PartialSpecific<TrackRemoveFromCartParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackRemoveFromCartParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        ...options,
    };

    return (parameters: Partial<TrackRemoveFromCartParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.removeFromCart({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackRemoveFromCart;
